module.exports = __webpack_public_path__ + "assets/ziyuan_17.dbbb9b35.svg";